/* nav-logo.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./nav-logo.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React, { useEffect, useRef } from 'react';
import { Anchor } from '@atlaskit/primitives';
import { useHasCustomTheme } from './themed/has-custom-theme-context';
export var themedLogoIcon = '--ds-top-bar-logo-icon';
export var themedLogoText = '--ds-top-bar-logo-text';
var navLogoStyles = {
  root: "_2rkoiti9 _1e0c1txw _4cvr1h6o _4t3izwfg",
  icon: "_18zr1b66 _1e0c1txw _p12f1tcg _vchh1ntv _10y4glyw",
  logo: "_18zru2gc _1e0cglyw _p12fnklw _vchh1ntv _10y41txw",
  imageContainer: "_1reo15vq _18m915vq _bna71tcg _rtys1kw7 _1jpx1f51"
};

/**
 * __Nav logo__
 *
 * The product logo for the top navigation.
 */
export var NavLogo = function NavLogo(_ref) {
  var href = _ref.href,
    logo = _ref.logo,
    icon = _ref.icon,
    onClick = _ref.onClick,
    label = _ref.label;
  var ref = useRef(null);
  useEffect(function () {
    var _img$parentElement, _img$parentElement2;
    if (process.env.NODE_ENV === 'production') {
      return;
    }
    if (!ref.current) {
      return;
    }
    var img = ref.current.querySelector('img');
    if (!img) {
      return;
    }

    /**
     * We want custom logo components to render the image as the immediate child
     */
    var hasExpectedStructure = ((_img$parentElement = img.parentElement) === null || _img$parentElement === void 0 ? void 0 : _img$parentElement.parentElement) === ref.current;
    /**
     * We want custom logo components to render only one image
     */
    var isOnlyChild = ((_img$parentElement2 = img.parentElement) === null || _img$parentElement2 === void 0 ? void 0 : _img$parentElement2.childElementCount) === 1;
    if (!hasExpectedStructure || !isOnlyChild) {
      // eslint-disable-next-line no-console
      console.error('Custom logos should render only a single image tag with no wrappers.');
    }
    if (img.getAttribute('width') !== null || img.getAttribute('height') !== null || img.style.width !== '' || img.style.height !== '') {
      // eslint-disable-next-line no-console
      console.error('Do not set explicit dimensions on custom logo images. The container will resize the image to fit.');
    }
  }, []);
  return /*#__PURE__*/React.createElement(Anchor, {
    ref: ref,
    "aria-label": label,
    href: href,
    xcss: navLogoStyles.root,
    onClick: onClick
  }, /*#__PURE__*/React.createElement("div", {
    className: ax([navLogoStyles.imageContainer, navLogoStyles.icon])
  }, /*#__PURE__*/React.createElement(NavLogoRenderer, {
    logoOrIcon: icon
  })), /*#__PURE__*/React.createElement("div", {
    className: ax([navLogoStyles.imageContainer, navLogoStyles.logo])
  }, /*#__PURE__*/React.createElement(NavLogoRenderer, {
    logoOrIcon: logo
  })));
};
function NavLogoRenderer(_ref2) {
  var LogoOrIcon = _ref2.logoOrIcon;
  var hasCustomTheme = useHasCustomTheme();
  if (hasCustomTheme) {
    return /*#__PURE__*/React.createElement(LogoOrIcon, {
      size: "small",
      label: "",
      iconColor: "var(".concat(themedLogoIcon, ")"),
      textColor: "var(".concat(themedLogoText, ")")
    });
  }
  return /*#__PURE__*/React.createElement(LogoOrIcon, {
    size: "small",
    label: "",
    appearance: "brand"
  });
}